import { useState } from 'react';
import SEOHead from '@/components/feature/SEOHead';
import SchemaOrg from '@/components/feature/SchemaOrg';
import Navbar from '@/components/feature/Navbar';
import Breadcrumb from '@/components/feature/Breadcrumb';
import Footer from '@/components/feature/Footer';

const faqData = [
  {
    question: '「她之间」是什么样的平台？',
    answer: '「她之间」是一个专注于女性与女性之间情感连接、故事分享和生活体验的内容社区。我们致力于为关注女女关系的读者提供一个温暖、安全、真实的内容空间，通过原创文章、真实故事和深度内容，呈现女女关系的多元面貌。',
  },
  {
    question: '如何投稿分享我的故事？',
    answer: '我们非常欢迎来自社区成员的真诚分享！你可以通过本页的"联系我们"表单发送你的故事概要。我们的编辑团队会在3个工作日内与你取得联系，沟通后续的稿件细节。所有投稿都会进行匿名化处理，保护你的隐私。',
  },
  {
    question: '平台上的文章都是真实的吗？',
    answer: '是的。我们发布的故事主要来源于社区成员的真实投稿，以及编辑团队对女性情感话题的深度探讨。在保护分享者隐私的前提下，我们尽可能还原真实的情感和经历，让每一位读者都能在这里找到共鸣。',
  },
  {
    question: '如何保护我的个人隐私？',
    answer: '我们非常重视每一位用户的隐私保护。所有投稿内容在发布前都会进行匿名化处理，包括但不限于人名、地名、工作单位等可识别信息。如需更加严格的匿名保护，可在投稿时说明，我们会采取额外的保护措施。',
  },
  {
    question: '平台是否支持LGBTQ+友好？',
    answer: '是的，我们是一个对LGBTQ+群体完全友好和包容的平台。我们相信每一份真挚的感情都值得被尊重和珍视。在这里，你可以自由地表达和分享，无需隐藏真实的自己。我们的内容团队和社区都致力于营造一个没有偏见和歧视的温暖空间。',
  },
  {
    question: '如何订阅平台的Newsletter？',
    answer: '很简单！你可以在首页底部的订阅区域输入你的邮箱地址，点击「订阅」按钮即可完成。我们会每周为你推送精选文章、热门故事和社区动态，让你不错过任何精彩内容。我们也承诺不会发送垃圾邮件，你可以随时退订。',
  },
];

function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  return (
    <section className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-100">
      <div className="max-w-3xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900">
            常见问题
          </h2>
          <p className="text-sm text-foreground-600 mt-3 leading-relaxed">
            关于「她之间」的一些常见问题，帮你更好地了解我们
          </p>
        </div>

        <div className="space-y-3">
          {faqData.map((faq, index) => (
            <div
              key={index}
              className="bg-background-50 rounded-lg border border-background-200/70 overflow-hidden"
            >
              <button
                type="button"
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                className="w-full flex items-center justify-between px-5 py-4 text-left cursor-pointer hover:bg-background-100/50 transition-colors"
              >
                <span className="text-sm font-medium text-foreground-800 pr-4">{faq.question}</span>
                <div className={`w-5 h-5 flex-shrink-0 flex items-center justify-center text-foreground-500 transition-transform duration-200 ${openIndex === index ? 'rotate-180' : ''}`}>
                  <i className="ri-arrow-down-s-line" />
                </div>
              </button>
              {openIndex === index && (
                <div className="px-5 pb-4">
                  <p className="text-sm text-foreground-600 leading-relaxed">{faq.answer}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

function ContactForm() {
  const [status, setStatus] = useState<'idle' | 'success' | 'error'>('idle');
  const [message, setMessage] = useState('');

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    const form = e.currentTarget;
    const formData = new FormData(form);
    const honeypot = formData.get('company_alt') as string;
    if (honeypot && honeypot.trim() !== '') {
      setStatus('success');
      setMessage('感谢您的留言！我们会尽快与您联系。');
      form.reset();
      return;
    }

    const name = formData.get('name') as string;
    const email = formData.get('email') as string;
    const content = (formData.get('message') as string || '').trim();

    if (content.length > 500) {
      setStatus('error');
      setMessage('留言内容不能超过500个字符。');
      return;
    }

    try {
      const response = await fetch('https://readdy.ai/api/form/d9sphol8o1vn02ekujng', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams({ name, email, message: content }).toString(),
      });
      const responseText = await response.text();
      const parsed = JSON.parse(responseText);

      if (response.ok && parsed?.code === 'OK') {
        setStatus('success');
        setMessage('感谢您的留言！我们会尽快与您联系。');
        form.reset();
      } else {
        setStatus('error');
        setMessage(parsed?.meta?.message || '提交失败，请稍后重试。');
      }
    } catch {
      setStatus('error');
      setMessage('网络错误，请稍后重试。');
    }
  };

  return (
    <section className="w-full px-4 md:px-6 py-14 md:py-20">
      <div className="max-w-xl mx-auto">
        <div className="text-center mb-8">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900">
            联系我们
          </h2>
          <p className="text-sm text-foreground-600 mt-3 leading-relaxed">
            有任何问题、建议或合作意向？我们很乐意倾听你的声音
          </p>
        </div>

        {status === 'success' ? (
          <div className="text-center p-8 bg-secondary-50 text-secondary-800 rounded-lg">
            <div className="w-14 h-14 flex items-center justify-center mx-auto mb-4 rounded-full bg-secondary-100 text-secondary-600">
              <i className="ri-check-line text-2xl" />
            </div>
            <p className="text-sm">{message}</p>
          </div>
        ) : (
          <form
            data-readdy-form=""
            onSubmit={handleSubmit}
            className="space-y-4"
          >
            <input
              type="text"
              name="company_alt"
              tabIndex={-1}
              autoComplete="off"
              aria-hidden="true"
              readOnly
              className="honeypot-field"
            />
            <div>
              <label htmlFor="contact-name" className="block text-sm font-medium text-foreground-700 mb-1.5">
                姓名
              </label>
              <input
                id="contact-name"
                type="text"
                name="name"
                required
                className="w-full px-4 py-2.5 text-sm bg-background-50 border border-background-300 rounded-lg focus:outline-none focus:border-primary-400 transition-colors"
                placeholder="你的称呼"
              />
            </div>
            <div>
              <label htmlFor="contact-email" className="block text-sm font-medium text-foreground-700 mb-1.5">
                邮箱
              </label>
              <input
                id="contact-email"
                type="email"
                name="email"
                required
                className="w-full px-4 py-2.5 text-sm bg-background-50 border border-background-300 rounded-lg focus:outline-none focus:border-primary-400 transition-colors"
                placeholder="your@email.com"
              />
            </div>
            <div>
              <label htmlFor="contact-message" className="block text-sm font-medium text-foreground-700 mb-1.5">
                留言内容
              </label>
              <textarea
                id="contact-message"
                name="message"
                rows={5}
                maxLength={500}
                required
                className="w-full px-4 py-2.5 text-sm bg-background-50 border border-background-300 rounded-lg focus:outline-none focus:border-primary-400 transition-colors resize-none"
                placeholder="分享你的想法、故事或建议（500字以内）"
              />
              <p className="text-xs text-foreground-500 mt-1">最多500个字符</p>
            </div>
            <button
              type="submit"
              className="w-full py-2.5 bg-primary-500 text-background-50 rounded-lg text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              发送留言
            </button>
          </form>
        )}

        {status === 'error' && (
          <p className="mt-3 text-xs text-red-500 text-center">{message}</p>
        )}

        <div className="mt-10 grid grid-cols-1 sm:grid-cols-3 gap-4 text-center">
          <div className="p-4 bg-background-100 rounded-lg">
            <div className="w-10 h-10 flex items-center justify-center mx-auto mb-2 rounded-full bg-accent-100 text-accent-600">
              <i className="ri-mail-line text-lg" />
            </div>
            <p className="text-xs text-foreground-600">hello@tazhijian.com</p>
          </div>
          <div className="p-4 bg-background-100 rounded-lg">
            <div className="w-10 h-10 flex items-center justify-center mx-auto mb-2 rounded-full bg-accent-100 text-accent-600">
              <i className="ri-wechat-line text-lg" />
            </div>
            <p className="text-xs text-foreground-600">她之间官方</p>
          </div>
          <div className="p-4 bg-background-100 rounded-lg">
            <div className="w-10 h-10 flex items-center justify-center mx-auto mb-2 rounded-full bg-accent-100 text-accent-600">
              <i className="ri-weibo-line text-lg" />
            </div>
            <p className="text-xs text-foreground-600">@她之间</p>
          </div>
        </div>
      </div>
    </section>
  );
}

export default function AboutPage() {
  return (
    <>
      <SEOHead
        title="关于我们"
        description="了解「她之间」的品牌故事、使命与价值观。一个专注于女性情感连接与故事分享的温暖社区，为女女关系提供真实、细腻的内容空间。"
        keywords="她之间,关于我们,女女社区,女性情感平台,联系我们"
        canonicalUrl="https://tazhijian.com/about"
      />
      <SchemaOrg
        type="WebPage"
        data={{
          name: '关于我们 | 她之间',
          url: 'https://tazhijian.com/about',
          description: '了解她之间的品牌故事、使命与价值观。',
          isPartOf: { '@type': 'WebSite', name: '她之间', url: 'https://tazhijian.com' },
        }}
      />
      <SchemaOrg
        type="BreadcrumbList"
        data={{
          itemListElement: [
            { '@type': 'ListItem', position: 1, name: '首页', item: 'https://tazhijian.com' },
            { '@type': 'ListItem', position: 2, name: '关于我们', item: 'https://tazhijian.com/about' },
          ],
        }}
      />
      <SchemaOrg
        type="FAQPage"
        data={{
          mainEntity: faqData.map((faq) => ({
            '@type': 'Question',
            name: faq.question,
            acceptedAnswer: {
              '@type': 'Answer',
              text: faq.answer,
            },
          })),
        }}
      />

      <Navbar />
      <main className="pt-16 md:pt-18">
        <Breadcrumb />

        <section className="w-full px-4 md:px-6 py-14 md:py-20">
          <div className="max-w-4xl mx-auto">
            <div className="text-center mb-12">
              <h1 className="text-2xl md:text-4xl font-heading font-bold text-foreground-900 mb-4">
                关于「她之间」
              </h1>
              <p className="text-sm md:text-base text-foreground-600 max-w-2xl mx-auto leading-relaxed">
                一个专注女性情感连接的内容社区，用故事传递温暖，用共鸣连接彼此
              </p>
            </div>

            <div className="relative w-full h-64 md:h-80 rounded-lg overflow-hidden mb-10">
              <img
                src="https://readdy.ai/api/search-image?query=Warm%20cozy%20living%20room%20with%20soft%20lighting%2C%20two%20armchairs%20by%20a%20window%2C%20plants%2C%20books%20on%20shelves%2C%20feminine%20interior%20design%2C%20cream%20and%20beige%20tones%2C%20peaceful%20atmosphere%2C%20sunlight%20streaming%20through%20curtains%2C%20artistic%20photography%2C%20shallow%20depth%20of%20field%2C%20intimate%20warm%20mood%2C%20community%20space%20vibe&width=1600&height=700&seq=about-hero-01&orientation=landscape"
                alt="她之间 - 温暖的社区空间"
                title="她之间 - 女女情感社区"
                className="w-full h-full object-cover object-top"
              />
            </div>

            <div className="space-y-8">
              <div>
                <h2 className="text-xl font-heading font-bold text-foreground-900 mb-3">
                  我们的故事
                </h2>
                <p className="text-sm text-foreground-700 leading-relaxed">
                  2024年春天，几个有着相似经历的女孩在一次聚会上聊到了同一个话题——"在这个世界上，关于我们女女之间感情的故事和内容太少了"。搜索到的信息要么是猎奇的，要么是刻板印象的，真正能让人产生共鸣的、温暖的、真实的内容，少之又少。
                </p>
                <p className="text-sm text-foreground-700 leading-relaxed mt-3">
                  于是，「她之间」诞生了。我们希望打造一个空间，让每一个关注女女关系的人——无论是正在探索自己感情的女孩，还是已经拥有稳定伴侣的女性——都能在这里找到属于自己的声音和故事。
                </p>
              </div>

              <div>
                <h2 className="text-xl font-heading font-bold text-foreground-900 mb-3">
                  我们的使命
                </h2>
                <p className="text-sm text-foreground-700 leading-relaxed">
                  我们相信，每一份真挚的情感都值得被看见、被记录、被珍视。「她之间」致力于通过真实的故事、深度的内容和温暖的社区，为女性之间的情感连接提供一个安全、包容、充满力量的内容空间。我们希望每一位来到这里的读者，都能感受到"原来我不是一个人"的共鸣与慰藉。
                </p>
              </div>

              <div>
                <h2 className="text-xl font-heading font-bold text-foreground-900 mb-3">
                  我们的价值观
                </h2>
                <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mt-4">
                  <div className="p-5 bg-background-100 rounded-lg text-center">
                    <div className="w-12 h-12 flex items-center justify-center mx-auto mb-3 rounded-full bg-primary-50 text-primary-500">
                      <i className="ri-heart-line text-xl" />
                    </div>
                    <h3 className="text-sm font-semibold text-foreground-800 mb-1">真诚</h3>
                    <p className="text-xs text-foreground-600 leading-relaxed">每一篇内容都以真诚为底色，拒绝猎奇、拒绝消费。</p>
                  </div>
                  <div className="p-5 bg-background-100 rounded-lg text-center">
                    <div className="w-12 h-12 flex items-center justify-center mx-auto mb-3 rounded-full bg-accent-50 text-accent-500">
                      <i className="ri-shield-check-line text-xl" />
                    </div>
                    <h3 className="text-sm font-semibold text-foreground-800 mb-1">安全</h3>
                    <p className="text-xs text-foreground-600 leading-relaxed">严格的隐私保护机制，让分享者安心讲述自己的故事。</p>
                  </div>
                  <div className="p-5 bg-background-100 rounded-lg text-center">
                    <div className="w-12 h-12 flex items-center justify-center mx-auto mb-3 rounded-full bg-secondary-50 text-secondary-500">
                      <i className="ri-group-line text-xl" />
                    </div>
                    <h3 className="text-sm font-semibold text-foreground-800 mb-1">包容</h3>
                    <p className="text-xs text-foreground-600 leading-relaxed">拥抱多元，尊重每一种生活方式和情感表达。</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <FAQ />
        <ContactForm />
      </main>
      <Footer />
    </>
  );
}